<ng-template #vista [ngIf]="modoVisualizacion === 'vista'">

    <app-banner *ngIf="tourData" [titulo]="tourData.name" [descripcion]="tourData.description" [margen]="bannerMargen"
        modoVisualizacion='vista' [imageUrl]="imageSanitizer">
    </app-banner>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <!-- Input de búsqueda en el mapa -->
                <br>
                <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
                    <ng-container *ngFor="let puntoTour of puntosTour">
                        <agm-marker [latitude]="puntoTour.coord.lat" [longitude]="puntoTour.coord.lng"></agm-marker>
                    </ng-container>
                    <agm-direction *ngIf="destino" [origin]="origen" [destination]="destino" [waypoints]="paradas"
                        [renderOptions]="opcionesRender" travelMode="WALKING" [optimizeWaypoints]="optimizarParadas"
                        (onResponse)="onResponse($event)" (onStatus)="onStatus($event)">
                    </agm-direction>
                </agm-map>
            </div>

            <div class="col-md-6">
                <div class="overflow-auto p-3 mb-3 mb-md-0 mr-md-3 bg-light" style="max-height: 600px;">
                    <ng-container *ngFor="let punto of puntosTour">
                        <div class="card-body">
                            <div aria-describedby="basic-addon2">{{punto.titulo}}</div>
                        </div>
                        <div class="overflow-auto scroll">
                            <ng-container *ngFor="let elementoMedia of punto.elementosMedia">
                                <app-add-media [mediaElement]="elementoMedia" modoVisualizacion="vista">
                                </app-add-media>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <ng-container *ngIf="showEdit()">
            <div class="card-body d-flex fixed-bottom justify-content-center">
                <div class="btn-group" role="group" aria-label="Basic example">
                <button class="btn btn-info" type="button" (click)="onEdit()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                      </svg>
                    Editar
                </button>
                <button *ngIf="tourData!=null && tourData.isPublished==false" class="btn btn-secondary" type="button" (click)="onPublish()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                      </svg>
                    Publicar
                </button>
                <button *ngIf="tourData!=null && tourData.isPublished==true" class="btn btn-secondary" type="button" (click)="onPublish()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
                      </svg>
                    Ocultar
                </button>
                </div>
            </div>
        </ng-container>
    </div>


</ng-template>

<ng-template #edicion [ngIf]="modoVisualizacion==='edicion'">
<!-- Button trigger modal -->
<button #botonEliminar type="button" class="btn d-none" data-toggle="modal" data-target="#deleteModal">
    Launch delete modal
  </button>
  
  <!-- Modal -->
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLongTitle">¿Seguro que quieres eliminar?</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Esta acción no se puede deshacer
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" (click)="onDelete()">Eliminar</button>
        </div>
      </div>
    </div>
  </div>

    <app-banner [titulo]="tourData.name" [descripcion]="tourData.description" [margen]="bannerMargen"
        modoVisualizacion='edicion' [imageUrl]="imageSanitizer" [showSelector]="showSelector">
    </app-banner>

    <div class="container-fluid" style="padding-bottom: 90px;">
        <div class="row">
            <div class="col-md-6">
                <!-- Input de búsqueda en el mapa -->
                <br>
                <div class="form-group">
                    <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()"
                        placeholder="Buscar lugar" autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                        #search>
                </div>
                <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" (mapClick)="onClickMap($event)">
                    <agm-marker *ngFor="let puntoTour of puntosTour" [latitude]="puntoTour.coord.lat"
                        [longitude]="puntoTour.coord.lng">
                    </agm-marker>
                    <agm-direction *ngIf="destino" [origin]="origen" [destination]="destino" [waypoints]="paradas"
                        [renderOptions]="opcionesRender" travelMode="WALKING" [optimizeWaypoints]="optimizarParadas"
                        (onResponse)="onResponse($event)" (onStatus)="onStatus($event)">
                    </agm-direction>
                </agm-map>
            </div>
            <div class="col-md-6">
                <div class="overflow-auto p-3 mb-3 mb-md-0 mr-md-3 bg-light" style="max-height: 600px;">
                    <ng-container *ngFor="let punto of puntosTour; index as i">
                        <div class="modal-content">
                            <div class="modal-header">
                                <input type="text" class="form-control-plaintext"
                                    placeholder="Titulo del punto" [(ngModel)]="punto.titulo"
                                    aria-describedby="basic-addon2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                    (click)="onPuntoTourDelete(i)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body overflow-auto scroll justify-content-center">
                                <ng-container *ngFor="let elementoMedia of punto.elementosMedia; index as j">
                                    <app-add-media mediaId="{{i}}-{{j}}" [mediaElement]="elementoMedia"
                                        modoVisualizacion="edicion"
                                        (created)="onMediaElementCreated(punto.elementosMedia)"
                                        (delete)="onMediaElementDelete(punto.elementosMedia,j)">
                                    </app-add-media>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="card-body d-flex fixed-bottom justify-content-center">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button class="btn btn-info" type="button" (click)=onSave()>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" 
                    fill="currentColor" class="bi bi-archive" viewBox="0 0 16 16">
                        <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                      </svg>
                    Guardar
                </button>
                <button class="btn btn-secondary" type="button" (click)="onCancel()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                      </svg>
                    Cancelar
                </button>
                <button *ngIf="tourData && tourData.id" class="btn btn-danger" type="button" (click)=onModalDelete()>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor"
                        class="bi bi-trash" viewBox="0 0 16 16">
                        <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                    </svg>
                    Eliminar
                </button>
            </div>
        </div>
    </div>

</ng-template>